import {BaseFormModel} from './base-form-model';
import {MembershipVisitHistorySummary} from './membership-visit-history-summary';
import {MembershipOrderItemHistory} from './membership-order-item-history';

export class MembershipVisitSummary extends BaseFormModel<MembershipVisitSummary> {
    historySummary: MembershipVisitHistorySummary;
    orderItemHistories: MembershipOrderItemHistory[];
}
